import { initRozcestnikZapsat } from './rozcestnikZapsatService';
import { initRozcestnikPostavil } from './rozcestnikPostavilService';
import { initRozcestnikZmenit } from './rozcestnikZmenitService';
import { initRozcestnikDalsi } from './rozcestnikDalsiService';
import rozcestnikZapisy from "../../content/rozcestnik/rozcestnikZapisy";
import { initRozcestnik } from "./rozcestnikService";
import { destroyElement } from "../../utils/common.mjs";

export function initRozcestnikZapisy(isPublic) {

    const tilesDiv = document.getElementById('tiles');
    tilesDiv.innerHTML = "";

    tilesDiv.appendChild(rozcestnikZapisy(isPublic));
    tilesDiv.style.display = "block";

    const divFormio = document.getElementById('divFormio');
    divFormio.style.display = "none";
    destroyElement('back-button-services');

    const home = document.getElementById('rozcestnikRoot');
    home.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnik(isPublic);

    });

    let rozcestnikZapsatTile = document.getElementById('rozcestnikZapsatTile');
    rozcestnikZapsatTile.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikZapsat(isPublic);
    });

    let rozcestnikPostavilTile = document.getElementById('rozcestnikPostavilTile');
    rozcestnikPostavilTile.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikPostavil(isPublic);
    });

    let rozcestnikZmenitTile = document.getElementById('rozcestnikZmenitTile');
    rozcestnikZmenitTile.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikZmenit(isPublic);
    });

    let rozcestnikDalsiTile = document.getElementById('rozcestnikDalsiTile');
    rozcestnikDalsiTile.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikDalsi(isPublic);
    });

    // IF LOGGED IN HIDE THE INVITATION PANEL    
    if (!isPublic) {
        const logininvitation = document.getElementById('logininvitation');
        logininvitation.style.display = 'none';
    }
}
